import React from "react";
import features from "../features.js";

function Features(){
    return(
        <div className="flex flex-col p-8 md:p-12 mb-20">
            <div className="flex text-3xl md:text-4xl lg:text-5xl justify-center p-10 md:p-14">
                <h2 className="flex uppercase font-normal">Why Join  us?</h2>
            </div>
            {/* flex justify-center p-4 md:p-8 gap-12 flex-wrap lg:flex-nowrap */}
            <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-10 p-1 md:p-4">
            {
                features.map((feature,index) => {
                    return (
                        <div className="flex flex-col font-sans gap-5 bg-neutral-50 shadow-xl rounded-2xl p-5 text-center" key={index}>
                            <div className="flex justify-center p-2">
                                <img className="flex w-20 h-20" src={feature.img} alt="" />   
                            </div>
                            <h5 className="flex text-xl md:text-2xl uppercase font-light justify-center text-black">{feature.title}</h5>
                            <p className="flex text-lg md:text-xl font-extralight text-black/80 text-justify">{feature.description}</p>
                        </div>
                    )
                })
            }
            </div>
            
        </div>
    )
}

export default Features;


// <div className="flex flex-col justify-center p-10">
//             <h1 className="text-3xl text-slate-950">Features</h1>
//             <div className="flex flex-col w-11/12 gap-y-14 mx-auto p-10 rounded-xl">
//                 <div className="flex justify-around w-full">
//                     <div className="flex">
//                         <img src={Attention} alt="" className="w-24"/>
//                         <p className="">Personal Attention</p>
//                     </div>
//                     <div className="flex">
//                         <img src={Study} alt="" className="w-24"/>
//                         <p className="">Printed Study Materials</p>
//                     </div>
//                 </div>
//                 <div className="flex justify-around w-full">
//                     <div className="flex">
//                         <img src={Weekly} alt="" className="w-24"/>
//                         <p className="">Weekly Test</p>
//                     </div>
//                     <div className="flex">
//                         <img src={Concept} alt="" className="w-24"/>
//                         <p className="">Concept Clearing Session</p>
//                     </div>
//                 </div>
//                 <div className="flex justify-around w-full">
//                     <div className="flex">
//                         <img src={Special} alt="" className="w-24"/>
//                         <p className="">Special Tricks and Shortcuts</p>
//                     </div>
//                     <div className="flex">
//                         <img src={Topic} alt="" className="w-24"/>
//                         <p className="">Topic Wise DPS</p>
//                     </div>
//                 </div>
//             </div>
//         </div>